<template>
  <section class="upcoming-shifts-empty">
    <Binoculars class="empty-state-illustration" />
    <p class="empty-state-description"> Je hebt op het moment geen geplande opdrachten. </p>
  </section>
</template>
<script setup lang="ts">
import Binoculars from '@app/illustrations/Binoculars.vue';
</script>
<style lang="scss">
.upcoming-shifts-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;

  .empty-state-illustration {
    height: 100%;
    max-width: 42px;
  }

  .empty-state-description {
    color: var(--pidz-grey-dark);
    font-size: 13px;
  }
}
</style>
